import { Fragment, ReactNode, useContext } from 'react';

import { AddFilterButton } from './AddFilterButton';
import { FilterSearch } from './FilterSearch';
import { FILTER_CONTEXT } from './provider';

import styles from './FilterBar.module.css';

type FilterControlsProps = {
  searchCollapsed?: boolean;
  hideSearch?: boolean;
  debounceTime?: number;
};

export const FilterControls = ({
  searchCollapsed = false,
  hideSearch = false,
  debounceTime = 300,
}: FilterControlsProps) => (
  <>
    {!hideSearch && (
      <FilterSearch
        searchCollapsed={searchCollapsed}
        debounceTime={debounceTime}
      />
    )}
    <AddFilterButton />
  </>
);

export const FilterBar = ({ children }: { children?: ReactNode }) => (
  <Fragment>
    <div className={styles.topContainer}>
      <FilterControls />
      {children}
    </div>
    <ActiveFilters />
  </Fragment>
);

export function ActiveFilters() {
  const context = useContext(FILTER_CONTEXT);

  if (!context)
    throw new Error('ActiveFilters must be used within a FiltersProvider');

  const { activeFilters, removeFilter, addFilter } = context;

  if (activeFilters.length === 0) return null;

  return (
    <div className={styles.chipContainer}>
      {activeFilters.map(activeFilter => (
        <Fragment key={`filter-${activeFilter.id}`}>
          {activeFilter.renderViewer({
            onValueChange: newValue => addFilter(activeFilter, newValue),
            onRemove: () => removeFilter(activeFilter.id),
          })}
        </Fragment>
      ))}
    </div>
  );
}
